import { UploadFile } from "antd";
import { HEAVY_FILE_TEXT } from "../config/types";

export const showProgressTextOnHeavyFiles = (fileList: UploadFile[], setProgressText: (text: string) => void) => {
  const fileListSize = fileList.reduce((acc, file) => acc + file.size!, 0);
  console.log("🚀 ~ fileListSize:", fileListSize);
  const heavyFile = fileListSize > (100 * 1024 * 1024); // 100 MB
  setProgressText(heavyFile ? HEAVY_FILE_TEXT : "");
};
